import { CustomHOCs } from "@thisgorilla/primate-ds";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { CONTENT_HIDDEN_Z_INDEX, CONTENT_Z_INDEX } from "../../../utils";
import { UserInfoPopup } from "./UserInfo";

type PopupProps = {
  parentRef: React.RefObject<HTMLDivElement>;
  type: "user";
  id: string;
};
export const Popup = (props: PopupProps) => {
  const { parentRef, type, id } = props;
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShowPopup(true);
    }, 100);
  }, []);

  return (
    <CustomHOCs.WithPopupPosition
      parentRef={parentRef}
      includeContentHeight={false}
      additionalOffset={20}
    >
      <Container $showPopup={showPopup} className={`${type}-popup`}>
        {type === "user" && <UserInfoPopup id={id} />}
      </Container>
    </CustomHOCs.WithPopupPosition>
  );
};

type ContainerProps = { $showPopup: boolean };

const Container = styled.div<ContainerProps>(({ $showPopup }) => {
  return `
    height: ${$showPopup ? "fit-content" : 0};
    width: ${$showPopup ? "fit-content" : 0};
    opacity: ${$showPopup ? 1 : 0};
    visibility: ${$showPopup ? "visible" : "hidden"};
    z-index: ${$showPopup ? CONTENT_Z_INDEX : CONTENT_HIDDEN_Z_INDEX};
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    pointer-events: ${$showPopup ? "auto" : "none"};
`;
});
